import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const whatsDifferentThisTime = useStore((state) => state.whatsDifferentThisTime);
  const setWhatsDifferentThisTime = useStore((state) => state.setWhatsDifferentThisTime);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.whatsDifferentThisTime.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={whatsDifferentThisTime}
          onChange={(value) => {
            setWhatsDifferentThisTime(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'whats-different-this-time',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"My mindset has changed"}>
            <span>💭</span> {t('onboarding.whatsDifferentThisTime.options.mindsetChanged')}
          </Option>
          <Option value={"I have a better plan"}>
            <span>🗒️</span> {t('onboarding.whatsDifferentThisTime.options.betterPlan')}
          </Option>
          <Option value={"My personal life has changed"}>
            <span>💞</span> {t('onboarding.whatsDifferentThisTime.options.lifeChanged')}
          </Option>
          <Option value={"My health has improved"}>
            <span>💪</span> {t('onboarding.whatsDifferentThisTime.options.healthImproved')}
          </Option>
          <Option value={"I’m more motivated"}>
            <span>🔥</span> {t('onboarding.whatsDifferentThisTime.options.moreMotivated')}
          </Option>
          <Option value={"Other"}>
            <span>🔹</span> {t('onboarding.whatsDifferentThisTime.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
